<card name="Радио">
  <div card content>
    <div class="form-check">
      <label class="check">
        <input class="check__input" name="custom" type="radio">
        <span class="check__box"></span>
        <span class="check__text">Обычный</span>
      </label>
    </div>
    
    <div class="form-check">
      <label class="check">
        <input class="check__input" name="custom" type="radio" checked>
        <span class="check__box"></span>
        <span class="check__text">Выбранный</span>
      </label>
    </div>
    
    <div class="form-check">
      <label class="check">
        <input class="check__input" name="custom-disabled" type="radio" disabled>
        <span class="check__box"></span>
        <span class="check__text">Заблокированный</span>
      </label>
    </div>
    
    <div class="form-check">
      <label class="check">
        <input class="check__input" name="custom-disabled" type="radio" checked disabled>
        <span class="check__box"></span>
        <span class="check__text">Выбранный блок.</span>
      </label>
    </div>
  </div>
</card>

